/**
 * 是否开启 console 打印
 *
 * @param {String} key 绑定到 window上的key值
 * @param {Boolean} open 默认是否开启
 * @param {*} changeKey 当设置值 与 当前值一样的时候才可以改变当前是否开启打印
 * @param {Array} [list=['log']] 开启监控的方法列表
 * @return {boolean|*}
 */

export default function (key, open, changeKey, list = ['log']) {
  // 是否开启调试

  list.forEach(k => {
    let fn = console[k].bind(console);
    console[k] = (...arg) => window[key] && fn(...arg);
  });

  Object.defineProperty(window, key, {
    get() {
      return open;
    },
    set(val) {
      val === changeKey && (open = !open);
    },
  });
}

